"use client"
import {useEffect, useState} from "react";
import TagManager from "@/grandus-lib/utils/gtag";
import useUser from "@/grandus-lib/hooks/useUser";
import isEmpty from "lodash/isEmpty";
import EnhancedEcommerce from '@/utils/ecommerce';

const ProductsListAnalytics = ({ products, pagination, listName }) => {
  const { user, isLoading: userIsLoading } = useUser();
  const [initialized, setInitialized] = useState(false);
  useEffect(() => {
    if (!isEmpty(products) && !userIsLoading && !initialized) {
      TagManager.push(
        EnhancedEcommerce.view_item_list(
          products,
          listName ?? 'products',
          {
            page: pagination?.currentPage,
            perPage: pagination?.perPage,
          },
          user
        )
      );
      setInitialized(true);
    }
  }, [products, pagination, user, userIsLoading])
}

export default ProductsListAnalytics;
